import Quill from 'quill';
import Theme from "./quill/Theme";
import FocusModule from "./quill/FocusModule";
// import EmbedBlot from "./quill/blots/Embed";
import './quill/AnchorModule';

export default {
    data() {
        return {
            Break: Quill.import('blots/break'),
        }
    },

    mounted() {

        let BlockEmbed = Quill.import('blots/block/embed');
        let Inline = Quill.import('blots/inline');
        let Block = Quill.import('blots/block');
        let Parchment = Quill.import('parchment');

        let vm = this;

        let alignOptions = { whitelist: ['right', 'center', 'justify'] };
        let AlignClass = new Parchment.Attributor.Class('align', 'align', alignOptions);
        Quill.register(AlignClass, true);


        class ImageBlot extends BlockEmbed {

            static formats(node) {
                return node.getAttribute('href');
            }

            static create(value) {
                let node = super.create();

                node.setAttribute('alt', value.alt);
                node.setAttribute('src', value.url);
                if (typeof value.id != 'undefined') {
                    node.setAttribute('id', value.id);
                }

                if (value.unsplash_id !== null) {
                    node.setAttribute('data-unsplash-id', value.unsplash_id);
                }

                return node;
            }

            constructor(domNode) {
                super(domNode);
            }

            static value(node) {
                return {
                    id: node.getAttribute('id'),
                    alt: node.getAttribute('alt'),
                    url: node.getAttribute('src')
                };
            }
        }

        ImageBlot.blotName = 'image';
        ImageBlot.tagName = 'img';
        Quill.register(ImageBlot);

        class VideoBlot extends BlockEmbed {
            static formats(node) {
                let format = {};
                return format;
            }

            static create(value) {
                let node = super.create();
                node.setAttribute('frameborder', '0');
                node.setAttribute('allowfullscreen', true);
                node.setAttribute('src', value.src);
                return node;
            }

            static value(node) {
                return node.getAttribute('src');
            }
        }

        VideoBlot.blotName = 'video';
        VideoBlot.tagName = 'iframe';
        Quill.register(VideoBlot);

        class CtaButtonBlot extends BlockEmbed {
            static create(value) {
                let node = super.create();

                let wrapperElement = document.createElement('p');
                let anchorElement = document.createElement('a');

                anchorElement.setAttribute('href', value.href.trim());
                anchorElement.setAttribute('target', value.target);
                anchorElement.setAttribute('class', value.class);
                anchorElement.text = value.text;

                wrapperElement.appendChild(anchorElement);

                node.appendChild(anchorElement);
                node.setAttribute('contenteditable', false);

                if (value.align) {
                    node.classList.add('align-'+value.align);
                }

                return node;
            }

            constructor(domNode) {
                super(domNode);
                domNode.addEventListener('click', function(e){
                    e.preventDefault();
                    vm.onLinkClick(this);
                }.bind(this));
            }

            static value(node) {
                let anchorElement = node.querySelector('a');
                if (!anchorElement) return null;
                return {
                    href: anchorElement.getAttribute('href'),
                    text: anchorElement.text,
                    class: anchorElement.getAttribute('class'),
                    target: anchorElement.getAttribute('target')
                };
            }

            static formats(node) {
                let align = false;
                if (node.classList.contains('align-center')) {
                    align = 'center';
                } else if (node.classList.contains('align-right')) {
                    align = 'right';
                }
                return {align: align};
            }
        }

        CtaButtonBlot.blotName = 'cta-button';
        CtaButtonBlot.className = 'btn-p';
        CtaButtonBlot.tagName = 'P';
        Quill.register(CtaButtonBlot);

        class LinkBlot extends Inline {

            static create(value) {
                let node = super.create(value);
                node.setAttribute('href', value.href.trim());
                node.setAttribute('target', value.target);
                return node;
            }

            constructor(domNode) {
                super(domNode);
                domNode.addEventListener('click', function(){
                    vm.onLinkClick(this);
                }.bind(this));
            }

            static formats(domNode) {
                if (domNode.getAttribute('href') === null) return null;

                return {
                    href: domNode.getAttribute('href'),
                    text: domNode.textContent,
                    target: domNode.getAttribute('target')
                }
            }

            format(name, value) {
                if (name === 'link' && value) {
                    this.domNode.setAttribute('href', value.href);
                    this.domNode.textContent = value.text;
                    this.domNode.setAttribute('target', value.target);
                } else {
                    super.format(name, value);
                }
            }

            formats() {
                let formats = super.formats();
                formats['link'] = LinkBlot.formats(this.domNode);
                return formats;
            }
        }

        LinkBlot.blotName = 'link';
        LinkBlot.tagName = 'A';
        Quill.register(LinkBlot, true);

        class BlockBlot extends Block  {
            formats() {
                let formats = super.formats();

                if (vm.isLineBreak(this) && !this.domNode.classList.contains('ql-line-break')) {
                    this.domNode.classList.add('ql-line-break');
                } else if (this.domNode.classList.contains('ql-line-break') && !vm.isLineBreak(this)) {
                    this.domNode.classList.remove('ql-line-break');
                }

                return formats;
            }
        }

        Quill.register(BlockBlot);

        class EmbedBlot extends BlockEmbed {
            static create(value) {
                let node = super.create(value);

                // node.contentEditable = true;

                node.setAttribute('id', value.id);
                node.setAttribute('data-embed-title', value.title);


                return node;
            }


            constructor(domNode) {
                super(domNode);

                domNode.innerHTML = '';

                let wrapper = document.createElement('div');
                wrapper.classList.add('ql-embed-wrap');
                wrapper.contentEditable = false;

                let title = domNode.getAttribute('data-embed-title') ? domNode.getAttribute('data-embed-title') : vm.$t__('Embedded Code');

                wrapper.innerHTML = `<i class="icon"><svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414" fill="currentColor"><path class="primary" d="M16.111 16H.889C.398 16 0 15.552 0 15V3c0-.552.398-1 .889-1h15.222c.491 0 .889.448.889 1v12c0 .549-.393.995-.889 1zm-1.764-1.991a.672.672 0 0 0 .668-.665V4.721a.669.669 0 0 0-.666-.664H2.651a.669.669 0 0 0-.666.664v8.623c0 .367.299.665.668.665h11.694z"/><path class="secondary" d="M10.335 5.548a.806.806 0 0 1 .472.192 73.741 73.741 0 0 1 2.758 2.758.776.776 0 0 1 0 1.004 73.741 73.741 0 0 1-2.758 2.758c-.596.508-1.638-.449-1.032-1.088L11.947 9c-.938-.938-2.288-1.948-2.383-2.593-.066-.445.224-.866.771-.859zM6.752 5.55c.59.054.898.838.48 1.278L5.061 9c1.161 1.162 2.747 2.229 2.302 3.057-.216.403-.805.507-1.162.203a73.741 73.741 0 0 1-2.758-2.758.776.776 0 0 1 0-1.004A73.741 73.741 0 0 1 6.2 5.74a.785.785 0 0 1 .551-.19z" fill-rule="nonzero"/></svg></i><span class="title">${title}</span><span class="btn-link has-border small narrow">${vm.$t__('Edit')}</span>`;

                this.leftGuard = document.createTextNode("\uFEFF");
                this.rightGuard = document.createTextNode("\uFEFF");
                // let whitespace = document.createTextNode("a");

                domNode.appendChild(this.leftGuard);

                domNode.appendChild(wrapper);

                // domNode.appendChild(this.rightGuard);

                let comment = document.createComment(" /ql-embed ");
                domNode.appendChild(comment);

                // domNode.appendChild(whitespace);

                domNode.addEventListener('mousedown', function(event){
                    event.stopImmediatePropagation();
                    event.preventDefault();

                    event.stopPropagation();
                    if (event.target.classList.contains('btn-link')) {
                        vm.onEmbedClick(this);
                    }
                    this.focus();

                }.bind(this));
            }

            length() {
                return 1;
            }

            index(node, offset) {

                if (node === this.leftGuard) return 0;
                if (node === this.rightGuard) return 1;
                return super.index(node, offset);
            }


            static value(node) {
                return {
                    'id': node.getAttribute('id'),
                    'title': node.getAttribute('data-embed-title')
                };
            }

            static formats(node) {
                let formats = [];
                if (node.classList.contains('align-center')) {
                    formats.align = 'center';
                }
                if (node.classList.contains('align-right')) {
                    formats.align = 'right';
                }
                return formats;
            }

            focus() {
                const selfPosition = this.offset(this.scroll);
                vm.editor.setSelection(selfPosition, 0, Quill.sources.USER);
                this.domNode.classList.add('isFocused');
                vm.editor.emitter.emit('embed-focus', this);
            }

            remove() {

                const offset = this.offset(vm.editor.scroll);
                super.remove();
                vm.editor.update(Quill.sources.USER);

                vm.editor.setSelection(offset, 0, Quill.sources.USER);
            }

            insertNewlineAfter() {
                const newBlot = Parchment.create("block", "");
                newBlot.insertInto(vm.editor.scroll, this.next);
                vm.editor.update(Quill.sources.USER);
                vm.editor.setSelection(this.offset() + 1, 0, Quill.sources.USER);
            }
        }

        EmbedBlot.blotName = 'embed';
        EmbedBlot.tagName = 'div';
        EmbedBlot.className = 'ql-embed';
        Quill.register({"formats/embed": EmbedBlot}, true);



        Quill.register({
            // "themes/pixenio": Theme,
            "modules/embed/focus": FocusModule,
        }, true);
    },

    methods: {
        isLineBreak(blockBlot) {
            return (blockBlot.children.length === 1 && blockBlot.children.head instanceof this.Break) ;
        },
    },

    formats: [
        'normal', 'header', 'blockquote', 'code-block',
        'bold', 'italic', 'underline',
        'list', 'align',
        'link', 'cta-button', 'image', 'embed', 'anchor',
    ]
}
